<template>
  <component :is="tag" :to="to" :href="href" class="brand-logo" :class="[size, { 'is-link': isLink }]" :aria-label="ariaLabel">
    <span class="brand-logo-icon-wrap" aria-hidden="true">
      <img class="brand-logo-icon" src="@/assets/img/logo_black.png" alt="" />
    </span>
    <span class="brand-logo-text">
      <img class="brand-wordmark" src="@/assets/img/logo_wordmark_white.png" alt="花小二" />
      <span class="brand-en">SMART</span>
    </span>
  </component>
</template>

<script>
export default {
  name: 'BrandLogo',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg'].includes(v)
    },
    to: {
      type: [String, Object],
      default: '/'
    },
    href: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: '花小二 SMART'
    }
  },
  computed: {
    isLink() {
      return !!(this.to || this.href)
    },
    tag() {
      if (this.to) return 'router-link'
      if (this.href) return 'a'
      return 'div'
    }
  }
}
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
  transition: opacity 0.3s ease, filter 0.3s ease;
}
.brand-logo.is-link {
  cursor: pointer;
}
.brand-logo.is-link:hover {
  opacity: 0.92;
}
.brand-logo.is-link:hover .brand-wordmark {
  filter: drop-shadow(0 0 6px rgba(56, 189, 248, 0.5));
}
.brand-logo.is-link:hover .brand-logo-icon-wrap {
  filter: drop-shadow(0 0 8px rgba(56, 189, 248, 0.45));
}

.brand-logo-icon-wrap {
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
  transition: filter 0.3s ease;
}
.brand-logo-icon {
  display: block;
  object-fit: cover;
  object-position: left center;
}

.brand-logo.sm .brand-logo-icon-wrap { width: 36px; height: 36px; }
.brand-logo.sm .brand-logo-icon { width: 90px; height: 36px; margin-left: 0; }
.brand-logo.sm .brand-wordmark { height: 22px; }
.brand-logo.sm .brand-en { font-size: 9px; letter-spacing: 2px; }

.brand-logo.md .brand-logo-icon-wrap { width: 42px; height: 42px; }
.brand-logo.md .brand-logo-icon { width: 105px; height: 42px; }
.brand-logo.md .brand-wordmark { height: 26px; }
.brand-logo.md .brand-en { font-size: 10px; letter-spacing: 3px; }

.brand-logo.lg .brand-logo-icon-wrap { width: 52px; height: 52px; }
.brand-logo.lg .brand-logo-icon { width: 130px; height: 52px; }
.brand-logo.lg .brand-wordmark { height: 34px; }
.brand-logo.lg .brand-en { font-size: 11px; letter-spacing: 4px; }

.brand-logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.brand-wordmark {
  display: block;
  width: auto;
  object-fit: contain;
  /* 纯白字形，透明底，适配深色导航/页脚 */
  filter: brightness(1.05);
  transition: filter 0.3s ease;
}
.brand-en {
  font-weight: 600;
  color: #e2e8f0;
  margin-top: 2px;
  transition: color 0.3s ease;
}
.brand-logo.is-link:hover .brand-en {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandLogo.vue